// extracted by mini-css-extract-plugin
module.exports = {"list":"MetricList_list__Ec1nz","item":"MetricList_item__D9FQX","wrapper":"MetricList_wrapper__3bxtT","value":"MetricList_value__b1D5Y","title":"MetricList_title__d2d1m"};